import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'

import AssumptionSection from './AssumptionSection'
import ActionText from '../../../../../../../components/ActionText'

import { ASSUMPTIONS, assumptionsOptions, initialAssumption } from '../../fields'

import useDrawerFormClasses from '../../../../../../../styles/common/drawerForms'

const AssumptionsSection = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  const [selectedAssumptionSectionIndex, setSelectedAssumptionSectionIndex] = useState(0)

  const { values, setFieldValue } = formik

  const assumptions = values[ASSUMPTIONS]

  const allowAddAnotherAssumption = useMemo(() => {
    return assumptions.length < assumptionsOptions.length
  }, [assumptions])

  const addAnotherAssumptionText = useMemo(() => {
    return values[ASSUMPTIONS].length > 0 ? t('Add another assumption') : t('Add assumption')
  }, [values, t])

  const handleAddAnotherAssumption = useCallback(() => {
    // add new initial assumption to assumptions array
    const currentAssumptions = values[ASSUMPTIONS]

    // open new assumption section
    setSelectedAssumptionSectionIndex(currentAssumptions.length)
    setFieldValue(ASSUMPTIONS, [...currentAssumptions, { ...initialAssumption, id: uuidv4() }])
  }, [setFieldValue, values])

  const handleDeleteAssumption = useCallback(
    index => {
      const newAssumptions = [...assumptions]
      newAssumptions.splice(index, 1)

      // open previous assumption section if it exists
      const nextSelectedIndex = index > 0 ? index - 1 : null
      setSelectedAssumptionSectionIndex(nextSelectedIndex)
      setFieldValue(ASSUMPTIONS, newAssumptions)
    },
    [assumptions, setFieldValue]
  )

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Assumptions')}</h3>

      {assumptions.map((assumption, index) => (
        <AssumptionSection
          formik={formik}
          index={index}
          key={assumption.id}
          isSelected={selectedAssumptionSectionIndex === index}
          onSelect={() => setSelectedAssumptionSectionIndex(index)}
          onClose={() => setSelectedAssumptionSectionIndex(null)}
          onDelete={() => handleDeleteAssumption(index)}
        />
      ))}
      {!!allowAddAnotherAssumption && (
        <ActionText onClick={handleAddAnotherAssumption} isDark>
          {t(addAnotherAssumptionText)}
        </ActionText>
      )}
    </section>
  )
}

export default AssumptionsSection
